import { Gift, Megaphone, PartyPopper, UserPlus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const ordinal = (n) => (n === 1 ? '1st' : n === 2 ? '2nd' : n === 3 ? '3rd' : `${n}th`)

const ICONS = {
  announcement: { Icon: Megaphone, bg: 'bg-primary/10', fg: 'text-primary' },
  kudos: { Icon: PartyPopper, bg: 'bg-[var(--magenta-3)]', fg: 'text-[var(--magenta-9)]' },
  prize_awarded: { Icon: Gift, bg: 'bg-[var(--orange-3)]', fg: 'text-[var(--orange-9)]' },
  member_joined: { Icon: UserPlus, bg: 'bg-primary/10', fg: 'text-primary' },
}

function PersonLink({ id, name }) {
  const navigate = useNavigate()
  return (
    <button
      type="button"
      onClick={() => navigate(`/profile/${id}`)}
      className="font-semibold hover:underline hover:opacity-80 transition-opacity"
    >
      {name || 'Unknown'}
    </button>
  )
}

function MessageBody({ item }) {
  const navigate = useNavigate()

  switch (item.kind) {
    case 'announcement':
      return (
        <>
          <p className="text-xs font-medium text-muted-foreground mb-1">
            {item.sender_name || 'Group owner'}
          </p>
          <p className="text-sm whitespace-pre-wrap break-words">{item.body}</p>
        </>
      )
    case 'kudos':
      return (
        <p className="text-sm">
          <PersonLink id={item.user_id} name={item.full_name} /> sent kudos to{' '}
          <PersonLink id={item.recipient_id} name={item.recipient_name} />: {item.kudos_message}
        </p>
      )
    case 'prize_awarded':
      return (
        <>
          <p className="text-sm">
            <PersonLink id={item.user_id} name={item.full_name} /> won{' '}
            <span className="font-semibold text-[var(--orange-11)]">{ordinal(item.prize_place)} place</span>
            {item.prize_name && <> - {item.prize_name}</>}
          </p>
          {item.bracket_name && (
            <button
              type="button"
              onClick={() => navigate(`/bracket/${item.bracket_id}/picks`)}
              className="text-xs text-primary hover:underline mt-0.5 block"
            >
              {item.bracket_name}
            </button>
          )}
        </>
      )
    default:
      return (
        <p className="text-sm">
          <PersonLink id={item.user_id} name={item.full_name} /> joined the group
        </p>
      )
  }
}

// One row of the group Messages feed, with the viewer's own "Hide" tick.
export default function GroupMessageItem({ item, hidden, onHiddenChange, formatTimeAgo }) {
  const { Icon, bg, fg } = ICONS[item.kind] || ICONS.member_joined

  return (
    <div className={`card-glass-item flex items-start gap-4 p-4 rounded-lg ${hidden ? 'opacity-60' : ''}`}>
      <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${bg}`}>
        <Icon className={`h-5 w-5 ${fg}`} />
      </div>
      <div className="flex-1 min-w-0">
        <MessageBody item={item} />
        <p className="text-xs text-muted-foreground mt-1">{formatTimeAgo(item.created_at)}</p>
      </div>
      <label className="flex items-center gap-1.5 text-xs text-muted-foreground cursor-pointer flex-shrink-0 select-none">
        <input
          type="checkbox"
          className="h-4 w-4 accent-primary"
          checked={!!hidden}
          onChange={(e) => onHiddenChange(item, e.target.checked)}
        />
        Hide
      </label>
    </div>
  )
}
